
class Dialog {
  constructor(dialog) {
    this.dialog = dialog;
    if (!this.dialog) return;

    this.dialog.addEventListener('click', event => {
      if (event.target === event.currentTarget) {
        this.close(this.dialog);
      }
    });

    const form = this.dialog.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => this.close(this.dialog));
    }
  }

  static bindTrigger(trigger) {
    trigger.addEventListener('click', () => {
      const target = trigger.getAttribute('aria-controls');
      if (!target) return;

      const dialogOpenTriggers = document.querySelectorAll(`[data-dialog-open="${target}"]`);
      const dialogCloseTriggers = document.querySelectorAll(`[data-dialog-close="${target}"]`);
      const dialogTriggers = [...dialogOpenTriggers, ...dialogCloseTriggers];
      dialogTriggers.forEach(t => t.setAttribute('aria-expanded', trigger.getAttribute('aria-expanded') === 'false' ? true : false));

      const targetDialog = document.getElementById(target);
      if (!targetDialog) return;

      let timer = 0;

      // Load the quick shop content
      if (trigger.getAttribute('data-dialog-quickshop-trigger')) {
        trigger.removeAttribute('data-dialog-quickshop-trigger');
        this.loadQuickShop(targetDialog);
        timer = 250;
      }

      if (trigger.getAttribute('data-dialog-open')) {
        setTimeout(() => {
          Dialog.show(targetDialog);
        }, timer);
      }
      else {
        targetDialog.close();
      }
    });
  }

  static dispatchEvent(target) {
    window.dispatchEvent(new CustomEvent('dialog:open', { detail: target, bubbles: true }));
  }

  static show(target) {
    target.showModal();
    Dialog.dispatchEvent(target);
  }

  close(target) {
    target.close();
  }

  static loadQuickShop(target) {
    const variantRadios = target.querySelector('variant-radios');
    variantRadios?.handleVariantChange(null, true);
  }
}

window.Dialog = Dialog;

window.initDialogs = function(container = document) {
  const dialogs = container.querySelectorAll('dialog');
  dialogs.forEach(dialog => {
    new Dialog(dialog);
  });

  const dialogOpenButtons = container.querySelectorAll('[data-dialog-open]');
  const dialogCloseButtons = container.querySelectorAll('[data-dialog-close]');
  const allDialogTriggers = [...dialogOpenButtons, ...dialogCloseButtons];
  allDialogTriggers.forEach(trigger => {
    Dialog.bindTrigger(trigger);
  });
};

window.initDialogs();

window.addEventListener('window:load-more', event => {
  initDialogs(event.detail.container);
});

window.addEventListener('shopify:section:load', event => {
  const sectionId = event.detail?.sectionId;
  if (!sectionId) return;
  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (sectionEl) {
    initDialogs(sectionEl);
  }
});
